export default {"src":"/_next/static/media/auth-by-spititory.f5eb61e3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};